export enum VehicleStatus {
  Operational,
  NotOperational,
  Stolen,
  Wrecked,
}
